import type { KeyboardEvent, Ref } from "react";
import clsx from "clsx";

const inputClass = "eh-input";

export interface AccessKeyFormValues {
  transponder_id: string;
  key_number: string;
}

export const EMPTY_ACCESS_KEY_FORM: AccessKeyFormValues = {
  transponder_id: "",
  key_number: "",
};

export interface AccessKeyFieldsProps {
  values: AccessKeyFormValues;
  onChange: (values: AccessKeyFormValues) => void;
  disabled?: boolean;
  className?: string;
  transponderInputRef?: Ref<HTMLInputElement>;
  onEnterKey?: () => void;
}

export function AccessKeyFields({
  values,
  onChange,
  disabled,
  className,
  transponderInputRef,
  onEnterKey,
}: AccessKeyFieldsProps) {
  function handleKeyDown(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter" && onEnterKey) {
      e.preventDefault();
      onEnterKey();
    }
  }

  return (
    <div className={clsx("grid gap-3 sm:grid-cols-2", className)}>
      <label className="text-sm">
        <span className="mb-1 block text-label-secondary">RFID-Transponder</span>
        <input
          ref={transponderInputRef}
          className={inputClass}
          value={values.transponder_id}
          onChange={(e) => onChange({ ...values, transponder_id: e.target.value })}
          onKeyDown={handleKeyDown}
          placeholder="Scannen oder eingeben…"
          disabled={disabled}
          autoComplete="off"
        />
      </label>
      <label className="text-sm">
        <span className="mb-1 block text-label-secondary">Schlüsselnummer</span>
        <input
          className={inputClass}
          value={values.key_number}
          onChange={(e) => onChange({ ...values, key_number: e.target.value })}
          onKeyDown={handleKeyDown}
          placeholder="z. B. 142"
          disabled={disabled}
          autoComplete="off"
        />
      </label>
    </div>
  );
}

export function accessKeysToApi(values: AccessKeyFormValues): {
  transponder_id: string | null;
  key_number: string | null;
} {
  const transponder = values.transponder_id.trim();
  const key = values.key_number.trim();
  return {
    transponder_id: transponder || null,
    key_number: key || null,
  };
}

export function accessKeysFromBooking(booking: {
  transponder_id?: string | null;
  key_number?: string | null;
}): AccessKeyFormValues {
  return {
    transponder_id: booking.transponder_id ?? "",
    key_number: booking.key_number ?? "",
  };
}

export type CheckInAccessKeys = ReturnType<typeof accessKeysToApi>;
